import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { isArray } from 'rxjs/internal-compatibility';
import { AccsessToAttributesComponent } from 'src/app/components/dialog/attributes/accsess-to-attributes/accsess-to-attributes.component';
import { AttributeDeletionConfirmationComponent } from 'src/app/components/dialog/attributes/attribute-deletion-confirmation/attribute-deletion-confirmation.component';
import { AccessToCategoriesComponent } from 'src/app/components/dialog/categories/access-to-categories/access-to-categories.component';
import { AccessToFileCategoriesComponent } from 'src/app/components/dialog/categories/access-to-file-categories/access-to-file-categories.component';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { DeletingRoleComponent } from 'src/app/components/dialog/roles/deleting-role/deleting-role.component';
import { UserOrgRolesActionsComponent } from 'src/app/components/dialog/roles/user-org-roles-actions/user-org-roles-actions.component';
import { UserOrgRolesControlsComponent } from 'src/app/components/dialog/roles/user-org-roles-controls/user-org-roles-controls.component';
import { ACTIONS_LIST } from 'src/app/constants';
import { ROLE_LIST_STATES } from 'src/app/constants/roles/roles-states';
import { ListParams, PaginationPageEvent, Res } from 'src/app/models';
import { Roles } from 'src/app/models/user-org-roles';
import { DialogModalService, LanguageService, NotificationService } from 'src/app/services';
import { ApiBasicService } from 'src/app/services/api-basic.service';
import { ApiUserOrgRolesService } from 'src/app/services/api-user-org-roles.service';
import { PaginationService } from 'src/app/services/pagination.service';

export type SortDirection = 'asc' | 'desc' | '';

@Component({
  selector: 'app-user-org-roles',
  templateUrl: './user-org-roles.component.html',
  styleUrls: ['./user-org-roles.component.css']
})

export class UserOrgRolesComponent implements OnInit {

  roles: Roles[] = [];
  paginationOutput: PaginationPageEvent;
  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  paginationInput: any;
  listParams: ListParams;
  language: string;
  loading: boolean;
  userRoleId: string;
  roleData: any;
  inputDataForForm: any;
  allIds: string[] = [];
  countSelectedFiles: number;
  amount: any;
  actionsList = [
    {
      id: "delete_selected",
      name: "Удалить выбранное",
      action: "PRODUCTS_DELETE"
    }
  ];

  headerDirection: any[] = [];
  sort: any = {};
  direction: SortDirection = 'asc';

  form: UntypedFormGroup = this.fb.group({
    search: ['']
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private notification: NotificationService,
    private apiUserOrgService: ApiUserOrgRolesService,
    private dialogModal: DialogModalService,
    private languageService: LanguageService,
    private apiBasic: ApiBasicService,
    private paginationService: PaginationService
  ) { }

  ngOnInit(): void {
    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(

      this.form.get('search').valueChanges.subscribe(val => {

        this.getList(val)

      })
    );

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    // если прилетает id перезагружаем список ролей
    this.subscriptions.add(
      this.apiUserOrgService.listenerRoleId().subscribe((val) => {

        if (val) {

          this.getList();
        }
      })
    );

    this.subscriptions.add(
      this.paginationService.listenerPaginationListData().subscribe(val => {

        if (val) {

          this.pageEvent(val);

        }
      })
    );
  }


  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }



  /**
  * 
  */
  getList(searchValue: string = ''): void {

    this.progressRef.start();
    this.loading = true;
    this.countSelectedFiles = 0;
    this.roles = [];

    this.setListParams(searchValue);


    this.apiUserOrgService.getList(this.listParams).subscribe((response: Res) => {
      console.log('[RESPONSE] getRoles: ', response);

      if (response != null && response.result.list != null) {

        this.roles = response.result.list;

        this.amount = response.result.count;

        this.paginationInput = {
          count: response.result.count,
          numberOfPages: response.result.numberOfPages,
          currentPage: this.listParams.pageNumber,
          size: this.listParams.countOnPage
        }
      }

      this.paginationService.setPaginationData(this.paginationInput);

      this.progressRef.complete();
      this.loading = false;
    },
      error => {
        this.progressRef.complete();
        this.loading = false;
      });
  }

  /**
* 
*/
  setListParams(searchValue): void {

    this.listParams = {
      filter: {
        name: searchValue,
        org_id: '',
        sort_by: this.sort.sortBy,
        direction: this.sort.direction
      },
      object: 'uroles_in_orgs',
      pageNumber: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }


  /**
   * 
   * @param attr_id 
   */
  sortData(attr_id: string) {

    const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

    if (this.sort.sortBy == attr_id) {

      this.headerDirection[0].direction = rotate[this.headerDirection[0].direction];

      this.sort.direction = this.headerDirection[0].direction;

    } else {

      let directionObj = {
        direction: this.direction
      }

      this.headerDirection.push(directionObj);

      let sortObj = {
        sortBy: attr_id,
        direction: this.direction
      }

      this.sort = sortObj;

    }

    this.getList();
  }

  openWindowWithButton(pop: any) {
    pop.open()
  }


  /**
   * 
   * @param attr_id 
   * @returns 
   */
  checkDirection(attr_id) {

    return this.sort.sortBy == attr_id ? this.sort.direction : '';

  }


  /**
   * 
   */
  isEmptyObject(obj) {

    return (obj && (Object.keys(obj).length === 0));

  }

  /**
* 
*/
  counterSelectedFiles() {

    this.countSelectedFiles = this.roles.filter(val => val.checked).length;
  }

  //   /**
  //  * 
  //  */
  //   chooseAllFiles() {

  //         this.allIds = response.result;

  //         this.roles.forEach(x => x.checked = true);

  //         this.countSelectedFiles = this.amount;

  //       }

  /**
* 
*/
  chooseAllFiles() {

    this.subscriptions.add(

      this.apiBasic.getAlListIds('roles', this.listParams).subscribe((response: Res) => {
        console.log("[RESPONSE] getAllProducts/ID: ", response);

        if (response != null) {

          this.allIds = response.result;

          this.roles.forEach(x => x.checked = true);

          this.countSelectedFiles = this.amount;

        }

        this.loading = false;
      },
        error => {
          this.loading = false;
        })

    );

  }

  /**
   * 
   */
  unChooseAllFiles() {
    this.roles.forEach(x => x.checked = false);
    this.allIds = [];
    this.countSelectedFiles = 0;
  }



  onClear(): any {

    this.form.get('search').setValue("");

  }


  /**
  * 
  * @param ids 
  */
  deleteOneRole(id: string[]) {

    let data = {
      id: [id]
    }

    this.dialogModal.open(data, DeletingRoleComponent).then(
      (result) => {

        if (result) {

          this.getList();
          this.notification.show('success', 'Роль успешно удалена');
        }
      },
      () => { console.log('Rejected!'); }
    );

  }


  /**
   * 
   */
  deleteSelected(roleid: string): void {

    // let ids = [...new Set(this.roles.filter(val => val.checked).map(({ urole }) => urole.id))];

    let data = {
      id: isArray(roleid) ? roleid : [roleid]
    }

    this.dialogModal.open(data, DeletingRoleComponent).then(
      (result) => {

        if (result == true) {

          this.notification.show('success', 'Данные успешно удалены!');
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   */
  onEdit(userRoleId) {

    let data = {
      u_role_id: userRoleId
    }

    this.dialogModal.open(data, UserOrgRolesControlsComponent, '', 'role-window').then(
      (result) => {

        if (result) {

          setTimeout(() => {
            this.getList();
          }, 500);

        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   */
  roleEditRights(id: string, role_id: string) {

    let data = {
      org_role_id: id,
      role_id: role_id
    }

    this.dialogModal.open(data, UserOrgRolesControlsComponent, 'xl').then(
      (result) => {

        if (result) {

          setTimeout(() => this.getList(), 1000);
          // this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
   * 
   */
  getAccessToAttribute(role_id) {

    let data = {
      role_id: role_id
    }

    this.dialogModal.open(data, AccsessToAttributesComponent, 'xl').then(
      (result) => {

        if (result) {

          // ПРОПИХНУТЬ В EDIT
          this.inputDataForForm = result;
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
   * 
   */
  getAccessToCategory(role_id) {

    let data = {
      role_id: role_id
    }

    this.dialogModal.open(data, AccessToCategoriesComponent, 'xl').then(
      (result) => {

        if (result) {



          // // ПРОПИХНУТЬ В EDIT
          // this.inputDataForForm = result;
          // this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  getAccessToFileCategory(role_id: number) {

    let data = {
      role_id: role_id
    }

    this.dialogModal.open(data, AccessToFileCategoriesComponent, 'xl').then(
      (result) => {

        if (result) {



          // // ПРОПИХНУТЬ В EDIT
          // this.inputDataForForm = result;
          // this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );

  }


  /**
   * 
   */
  roleLockAndUnlockControl(roleId: number, action: boolean): void {

    let data = {
      body: {
        id: [roleId],
        block: action
      }
    }

    this.subscriptions.add(
      this.apiUserOrgService.roleLockAndUnlockControl(data).subscribe(response => {

        if (response != null) {

          if (action) {

            this.notification.show('success', 'Роль заблокирована!');
          } else {

            this.notification.show('success', 'Роль разблокирована!');
          }

          this.getList();
        }

        this.progressRef.complete();
      })
    );
  }


  /**
  * 
  */
  onCreate() {

    let data = {
      products: this.roles.filter(val => val.checked)
    }

    this.dialogModal.open(data, UserOrgRolesActionsComponent).then(
      (result) => {

        if (result) {

          // ПРОПИХНУТЬ В EDIT
          this.inputDataForForm = result;
          this.getList();
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
  * 
  * @param event PaginationPageEvent
  */
  pageEvent(event: PaginationPageEvent): void {

    this.countSelectedFiles = 0;
    this.paginationOutput = event;
    this.getList();
  }

  /** CHECKBOX */

  /**
   * 
   * @param index number
   * @param event 
   */
  selectedCheckBox(index: number, event: any): void {

    this.roles[index].checked = event.target.checked;
    this.counterSelectedFiles();
  }


  /**
   * 
   * @param event 
   */
  checkAllCheckBox(event: any): void {

    let fc = this.roles.filter(val => val.checked).length;

    this.roles.forEach(x => fc > 0 ? x.checked = false : x.checked = event.target.checked);

    this.counterSelectedFiles();
  }


  /**
   * 
   * @returns boolean
   */
  isAllCheckBoxChecked(): boolean {

    if (this.roles.length == 0) return false;

    return this.roles.every(p => p.checked);
  }


  /**
   * 
   * @returns boolean
   */
  checkedButNotAllCheckBox(): boolean {

    let pl = this.roles.length;
    let pc = this.roles.filter(val => val.checked).length;

    return (pc > 0 && pc < pl) ? true : false;
  }


  /**
   * 
   * @returns boolean
   */
  checkedCheckBox(): boolean {

    if (this.roles) {

      let pc = this.roles.filter(val => val.checked).length;

      return (pc > 0) ? true : false;
    }
  }


  /**
   * 
   * @param id 
   * @returns 
   */
  getRoleStatus(stateId: string): string {

    let roleStatus: any = ROLE_LIST_STATES.find(val => val.id == stateId);

    return roleStatus != undefined ? roleStatus.name : 'Статус не определен';

  }

}
